import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["h-spinner", _ctx.color])
  }, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("div", null, null, -1),
    _createElementVNode("div", null, null, -1),
    _createElementVNode("div", null, null, -1),
    _createElementVNode("div", null, null, -1)
  ]))], 2))
}